import styled from 'styled-components';

export const AdminStampWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px;
  border-radius: 6px;
  font-size: 12px;
  color: #fff;
  background-color: ${({ color }) => color};
`;
